import styled from 'styled-components';

export const SecurityPillStyles = styled.div`
	.pill {
		display: flex;
		align-items: center;
		border: 1px solid ${(props) => props.theme.v3.colors.gray[4]};
		border-radius: 1rem;
		padding: 0.25rem 0.5rem;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
`;
